import { useSkippableQuery } from '../../useSkippableQuery';
import { useUser } from '../../useUser';
import { PAYMENT_METHODS_QUERY } from './paymentMethodsQuery.rest';

export const usePaymentMethodsQuery = () => {
  const {
    user: { accessToken }
  } = useUser();
  return useSkippableQuery(PAYMENT_METHODS_QUERY, { skip: !accessToken });
};
